<template>
  <div class="s-my-video-container">
    <div class="query_container">
      <el-form :model="formInline" style="display: flex; flex-wrap: nowrap;">

        <el-form-item label="结果" style="width: 300px;">
          <el-col :span="18">
            <el-select
                v-model="formInline.state"
                size="small"
                placeholder="结果"
                @change="stateChange"
            >
              <el-option label="全部" value=""></el-option>
              <el-option label="已接通" value="1"></el-option>
              <el-option label="未接通" value="0"></el-option>
            </el-select>
          </el-col>
        </el-form-item>

        <el-form-item label="时间">
          <el-row>
            <el-col :span="10">
              <el-date-picker
                  v-model="formInline.queryStartTime"
                  type="date"
                  placeholder="选择开始日期"
                  size="small"
                  value-format="yyyy-MM-dd"
              ></el-date-picker>
            </el-col>
            <el-col :span="1">
              <p style="text-align:center">~</p>
            </el-col>
            <el-col :span="10">
              <el-date-picker
                  v-model="formInline.queryEndTime"
                  type="date"
                  size="small"
                  placeholder="选择结束日期"
                  value-format="yyyy-MM-dd"
              ></el-date-picker>
            </el-col>
          </el-row>
        </el-form-item>


        <el-form-item>
          <div class="issue" @click="onSubmit">搜索</div>
        </el-form-item>

      </el-form>
    </div>
    <div class="section-list" style="width: 100%">
      <el-table
          :data="videoList"
          border
          style="width: 100%"
          :header-cell-style="{background:'#6baf6f',color:'#fff'}"
      >
        <el-table-column prop="fromUserName" label="账号" align="center"></el-table-column>
        <el-table-column prop="createTime" label="时间" align="center"></el-table-column>
        <el-table-column prop="talkTime" label="通话时长" align="center"></el-table-column>

        <el-table-column prop="state" label="结果" align="center" width="120">
          <template
              slot-scope="scope"
          >
            <span :class="scope.row.state == '0'?'state_red':'state_normal'">{{scope.row.state == '0'?'未接通':'已接通'}}</span>
          </template>
        </el-table-column>

        <el-table-column label="操作" align="center" width="120">
          <template slot-scope="scope">
            <span class="telephone_btn" @click="getItem(scope.row.fromUserId)">通话</span>
          </template>
        </el-table-column>

      </el-table>
      <el-pagination
          class="tab_pagination"
          background
          :pageSize="pageSize"
          layout="prev, pager, next"
          @current-change="currentChange"
          :total="total"
      ></el-pagination>
    </div>
  </div>
</template>

<script>
import echarts from "../utils/js/echartsServer";
import {getMyvideoList} from "@/utils/api/video";
export default {
  name: "myVideo",
  data() {
    return {
      formInline: {
        state: "",
        queryStartTime: "",
        queryEndTime: ""
      },
      videoList: [],
      currentPage: 1,
      pageSize: 10,
      total: 0,

      //视频语音
      roomId: 0,
      exportId: '',
      userId: '',
      line_type: ''
    };
  },
  mounted() {
    console.log('获取getMyExpertId:',this.$parent.getMyExpertId())
    this.getMyvideoList()
  },
  methods: {
    //视频
    getItem(id) {
      this.exportId = id
      this.line_type = '5'
      this.$parent.getVideoPlay();
      // this.$emit('videoPlay')
    },
    onSubmit() {
      if (
          (this.formInline.queryStartTime && !this.formInline.queryEndTime) ||
          (!this.formInline.queryStartTime && this.formInline.queryEndTime)
      ) {
        this.$message({
          message: "搜索数据请选择时间区间",
          type: "warning"
        });
        return;
      }
      let dataYear = [];
      if (this.formInline.queryStartTime && this.formInline.queryEndTime) {
        dataYear = [
          this.formInline.queryStartTime+' 00:00:00',
          this.formInline.queryEndTime+' 00:00:00'
        ];
      } else {
        dataYear = [];
      }
      this.getMyvideoList(dataYear);
    },
    currentChange(value) {
      this.currentPage = value;
      this.getMyvideoList();
    },
    stateChange(value) {
      this.formInline.state = value
    },
    //福安历年茶园种植面积
    async getMyvideoList(dataYear) {
      let res = await getMyvideoList({
        currentPage: this.currentPage,
        pageSize: this.pageSize,
        queryEndTime: dataYear?dataYear[0]:'',
        queryStartTime: dataYear?dataYear[1]:'',
        toUsreId: this.$parent.getMyExpertId(),
        state: this.formInline.state
      });

      this.total = res.data.data.total;
      this.videoList = res.data.data.records;
    },
  }
};
</script>

<style lang="scss" scoped>
@mixin baseBlockSet($display:block,$w:inherit,$h:inherit,$lineHeight:inherit,$texteAlign:none,$fontSize:inherit,$color:inherit,$fontFamily:inherit,$fontWeight:inherit,$cursor:auto,$backgroundColor:none){
  display: $display;
  width: $w;
  height: $h;
  line-height: $lineHeight;
  font-size: $fontSize;
  font-weight: $fontWeight;
  font-family: $fontFamily;
  text-align: $texteAlign;
  color: $color;
  background-color: $backgroundColor;
  cursor:$cursor
}
.s-my-video-container{
  .issue {
    @include  baseBlockSet($display:inline-block,$w:80px,$h:35px,$lineHeight:35px,$texteAlign:center,$fontSize:18px,$color:#fff,$fontFamily:PingFangSC,$fontWeight:400,$cursor:pointer);
    background: linear-gradient(90deg, #1cba4d, #a1dc61);
    border-radius: 8px;
    margin-left: 20px;
  }
  .section-list{
    .state_red{
      color: red;
    }
    .state_normal{
      color: #606266;
    }
    .telephone_btn{
      border-radius: 4px;
      color: #6baf6f;
      border: 1px solid #6baf6f;
      padding: 1px 10px;
      cursor: pointer;
    }
  }
}
</style>
<style lang="scss">
//.s-my-video-container{
//  .search_input {
//    width: 212px;
//
//    display: inline-block;
//  }
//  .el-input--suffix .el-input__inner {
//    border-radius: 10px;
//  }
//  .el-input--small .el-input__inner {
//    height: 40px;
//    line-height: 40px;
//  }
//}
</style>
